<template>
  <v-layout>
    <v-flex>
      <div class="ml-4 pt-4 pb-2">
        <slot></slot>
      </div>
    </v-flex>
    <v-flex v-if="hasAction" shrink pr-4 pt-2 pb-0>
      <slot name="action"></slot>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash'

export default {
  computed: {
    hasAction() {
      return this.hasSlot('action')
    }
  },
  methods: {
    hasSlot(name) {
      const slot = this.$slots[name]
      return !_.isNull(slot) && !_.isUndefined(slot)
    }
  }
}
</script>
